import { useQuery } from "@tanstack/react-query";
import { create } from "zustand";
import { useFilter } from "@/services/filter/filterStore";
import { companyService } from "../companyService";
import { type GetCompanyResponse } from "../companyTypes";

export const useCompanyStore = create<{
  currentCompany: GetCompanyResponse | null;
  setCurrentCompany: (company: GetCompanyResponse) => void;
}>(set => ({
  currentCompany: null,
  setCurrentCompany: company => set({ currentCompany: company }),
}));

export const useGetCompanies = () => {
  const { setCurrentCompany } = useCompanyStore();

  const {
    data: companies,
    isPending,
    isFetching,
    isLoading,
  } = useQuery({
    queryKey: ["companies"],
    queryFn: async () => {
      const companies = await companyService.getCompanies();

      setCurrentCompany(companies[0] ?? null);

      // O filtro global fica persistido: se a empresa salva saiu da lista
      // (excluída ou sem acesso), volta para "Todas as empresas".
      const { filters, removeCompany } = useFilter.getState();
      if (
        filters.company?.id &&
        !companies.some(company => company.id === filters.company?.id)
      ) {
        removeCompany();
      }

      const allCompaniesOption: GetCompanyResponse = {
        id: undefined,
        description: "Todas Lojas",
        identifier: "",
      };

      return [allCompaniesOption, ...companies];
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: false,
    staleTime: 1 * 60 * 1000,
    gcTime: 1 * 60 * 1000,
  });

  return {
    companies,
    isLoadingCompanies: isPending || isFetching || isLoading,
  };
};
